import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthProvider';

const Login = () => {
    const { register, reset, formState: {errors}, handleSubmit } = useForm();
    const { signIn, googleSignIn, resetPassword} = useContext(AuthContext);
    const [loginError, setLoginError] = useState('');
    const navigate = useNavigate();


    const handleLogin = data => {
        console.log(data);
        signIn(data.email, data.password)
        .then(result => {
            const user = result.user;
            navigate('/');
            // console.log(user);   
            reset();         
        })
        .catch(error => {
            console.log(error.message);
            setLoginError(error.message)
        })
    }

    const handleGoogleSignIn = () => {
        googleSignIn()
        .then(result => {
            const user = result.user;
            navigate('/');
          
            reset();   
        })
        .catch(err =>console.error(err));
    }

    const handleResetPassword =(data)=>{
        console.log(data.email);
        resetPassword()
        .then(result => {
            const user = result.user;
            
        })
        .catch(err => console.error(err))
    }



    return (
        <div className='h-[800px] flex justify-center items-center'>
        <div className='w-96 p-7'>
            <h2 className='text-xl text-center'>Login</h2>
            <form onSubmit={handleSubmit(handleLogin)}>

                <div className="form-control w-full max-w-xs">
                    <label className="label">
                        <span className="label-text">Email</span>
                    </label>
                    <input type='text'
                     {...register("email", {
                        required:"Email Address is required"
                    })} 
                     className="input input-bordered w-full max-w-xs" />
                       {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                </div>

                <div className="form-control w-full max-w-xs">
                    <label className="label">
                        <span className="label-text">Password</span>
                    </label>
                    <input type='password'
                     {...register("password", {
                        required:"Password is required",
                        minLength: {
                            value:6,
                            message: 'Password must be 6 characters or longer'
                        }
                    })}                       

                      className="input input-bordered w-full max-w-xs" />
                      
                    <label className="label">
                       <button onClick={handleResetPassword}> <span className="label-text">Forget Password?</span></button>
                    </label>
                    {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}


                </div>
                <input className='btn btn-accent w-full' value="Login" type="submit" />
                <div>
                    {
                       loginError && <p className='text-red-600'>{loginError} </p>  
                    }
                </div>
            </form>
            <p>New to BikeMart <Link className='text-secondary' to="/signup">Create an Account</Link></p>
            <div className="divider">OR</div>
            <button onClick={handleGoogleSignIn} className='btn btn-outline w-full'>CONTINUE WITH GOOGLE</button>
        </div>
    </div>
    );
};

export default Login;